module.exports = __webpack_public_path__ + "img/step1.3bb224b8.png";